import { GtmAppConfigInput, GtmInitArgs } from "./types";

/**
 * Values are considered "configured" only when non-empty and not an unsubstituted
 * config.json.dist placeholder (e.g. "##GTM_AUTH##"), which happens when a deploy
 * target doesn't set the corresponding environment variable.
 */
const isConfigured = (value?: string | null): value is string => {
  const trimmed = value?.trim();

  if (!trimmed) {
    return false;
  }

  return !(trimmed.startsWith("##") && trimmed.endsWith("##"));
};

/**
 * Resolves the arguments for `TagManager.initialize`.
 *
 * - `gtmId` is always required; returns `null` when missing so callers can skip init entirely.
 * - `auth` and `preview` are only applied when BOTH are configured (GTM Environments require
 *   both to be set together). Otherwise the standard production snippet (container ID only) is used.
 *
 * No environment name (dev/staging/prod) is hardcoded — behavior depends only on the
 * presence of auth + preview, so additional GTM environments can be added purely via config.
 */
export const resolveGtmInitArgs = ({ gtmId, auth, preview }: GtmAppConfigInput): GtmInitArgs | null => {
  if (!isConfigured(gtmId)) {
    return null;
  }

  if (isConfigured(auth) && isConfigured(preview)) {
    return { gtmId: gtmId.trim(), auth: auth.trim(), preview: preview.trim() };
  }

  return { gtmId: gtmId.trim() };
};
